import Title from "../../components/ui/Title"
import { Link } from "react-router-dom"
import Button from "../../components/ui/Button"
import '../../styles/pages/system.scss'

const ATBattles = () => {
    return (
        <div className="page-container">
            <div className="line-container">
            <Title
                text="System"
                size="full"
            />
            <header className="system-header">
                <h1 className="system-title">
                    AT Battle: A masterfully tactical battle system!
                </h1>
                <p>
                    The <i>Trails</i>' series classic AT Battle system returns! Watch the turn order for enemies and allies carefully and position your characters on the battlefield to seize victory.
                </p>
                <p>
                    Get the drop on your foes by striking enemies on the field and manipulate the turn order to claim powerful AT bonuses and turn the tide of battle.
                </p>
            </header>
            <div className="system-pair">
                <div className="system-info">
                    <div className="system-info_image">
                        <img src={`${process.env.PUBLIC_URL}/img/ss/at-1.webp`} alt="AT Battle Images" />
                    </div>
                    <h1 className="system-info_title">
                        The AT Battle System
                    </h1>
                    <p>
                        The AT Bar on the left side of the screen shows the order of enemy and ally turns. Special bonuses may be added to certain turns. These AT Bonuses can have a number of effects such as restoring HP or letting the character deal critical damage. Watch out, though! If you're not careful, enemies can claim these bonuses for themselves!
                    </p>
                    <p>
                        Be sure to pay close attention to what bonuses are coming up on the AT Bar and adjust your tactics accordingly.
                    </p>
                    <h1 className="system-info_title">
                        Team Rush
                    </h1>
                    <p>
                        One particularly powerful AT bonus is the new Team Rush! This bonus lets all your teammates attack at once, and is perfect for dealing a lot of damage quickly.
                    </p>
                    <p>
                        Work together with your whole squad to take down formidable foes!
                    </p>
                </div>
            </div>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Field Attacks
                    </h1>
                    <p>
                        If you press the attack button while on the field map, your lead character will perform an attack. Striking an enemy with one of these field attacks will stun them, and if you engage a stunned enemy, you'll receive potent combat bonuses.
                    </p>
                    <p>
                        However, keep in mind that enemies can also gain these bonuses if they ambush you. The same battle can play out very differently depending on how it starts!
                    </p>
                    <p>
                        If your level is significantly higher than an enemy's, you can even defeat them instantly by hitting them with a field attack—no battle required!
                    </p>
                </div>
                <div className="system-info_image">
                    <img src={`${process.env.PUBLIC_URL}/img/ss/at-2.webp`} alt="AT Battle Images" />
                </div>
            </div>
            <Link to="/system">
                <Button
                    text="Go Back"
                    type="solid"
                />
            </Link>
            </div>
        </div>
    )
}

export default ATBattles